import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import { api } from "../api";

// Karuzela opinii o sklepie na stronie głównej — te same opinie co na podstronie /opinie
export function Testimonials() {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    api.get("/reviews?limit=8").then((r) => setItems(r.data.items)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!items.length) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  const more = (
    <div className="mt-8 text-center">
      <Link to="/opinie" data-testid="testimonials-all-link" className="inline-flex items-center gap-2 rounded-full glass-panel px-6 py-2.5 text-sm font-semibold text-cyan-300 transition-colors hover:text-white">
        {items.length ? "Wszystkie opinie o DigiLib.store" : "Wystaw pierwszą opinię o DigiLib.store"} <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
  if (!items.length) return more;
  const item = items[index % items.length];
  const initials = item.name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();

  return (
    <div className="relative mx-auto max-w-3xl" data-testid="testimonials-carousel">
      <Quote className="absolute -top-6 left-1/2 h-12 w-12 -translate-x-1/2 text-cyan-500/30" />
      <div className="glass-panel rounded-3xl px-6 py-10 text-center sm:px-12">
        <div className="flex justify-center gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className={`h-5 w-5 ${i < item.rating ? "fill-amber-400 text-amber-400" : "text-slate-600"}`} />
          ))}
        </div>
        <p className="mt-6 text-lg leading-relaxed text-slate-200 sm:text-xl">„{item.text}"</p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 font-display text-sm font-bold text-white">
            {initials}
          </div>
          <div className="text-left">
            <div className="flex items-center gap-1.5 font-semibold text-slate-100">
              {item.name}
              {item.verified && <BadgeCheck className="h-4 w-4 text-cyan-400" />}
            </div>
            {item.product_title && <div className="text-xs text-slate-400">{item.product_title}</div>}
          </div>
        </div>
      </div>
      <div className="mt-6 flex items-center justify-center gap-4">
        <button onClick={() => setIndex((index - 1 + items.length) % items.length)} aria-label="Poprzednia opinia" className="rounded-full glass-panel p-2 text-slate-300 transition-colors hover:text-cyan-300">
          <ChevronLeft className="h-5 w-5" />
        </button>
        <div className="flex gap-2">
          {items.map((_, i) => (
            <button key={i} onClick={() => setIndex(i)} aria-label={`Opinia ${i + 1}`} className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? "w-8 bg-cyan-400" : "w-3 bg-slate-700"}`} />
          ))}
        </div>
        <button onClick={() => setIndex((index + 1) % items.length)} aria-label="Następna opinia" className="rounded-full glass-panel p-2 text-slate-300 transition-colors hover:text-cyan-300">
          <ChevronRight className="h-5 w-5" />
        </button>
      </div>
      {more}
    </div>
  );
}
